<template>
    <div
        v-if="isShowModal"
        :style="commonConfigStyles"
        class="o-tiles-modal-3"
        @click.self="closeModal"
    >
        <div class="tiles-modal-3-container">
            <header class="tiles-modal-3-header">
                <ATextButton
                    :text="$t('ui.close')"
                    theme="black"
                    icon="close-white"
                    @onClick="closeModal"
                />
            </header>
            <OModalItemDetails3
                :item="item"
                :item-name="itemName"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import ATextButton from '../../atoms/a-text-button';
import OModalItemDetails3 from '../../organisms/o-modal-item-details-3';

import { EVENTS } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'OTilesModal3',
    components: {
        ATextButton,
        OModalItemDetails3
    },
    data() {
        return {
            itemId: null,
            isShowModal: false
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getObject',
            'getMapConfigProp'
        ]),
        item() {
            return this.getObject(this.itemId) || null;
        },
        itemName() {
            return this.t(this.item, "name") || '';
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OTilesModal3.styles') || null;
        }
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    methods: {
        initListeners() {
            this.$bus.$on(EVENTS.MODALS.INIT_TILES_MODAL, this.initModal);
            this.$bus.$on(EVENTS.MODALS.OFF_MODAL, this.closeModal);
        },
        removeListeners() {
            this.$bus.$off(EVENTS.MODALS.INIT_TILES_MODAL, this.initModal);
            this.$bus.$off(EVENTS.MODALS.OFF_MODAL, this.closeModal);
        },
        initModal(id) {
            this.itemId = id;
            this.isShowModal = true;
        },
        closeModal() {
            this.isShowModal = false;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />